import { render } from "./upload.html?vue&type=template&id=67e2d45c&ts=true&external"
import script from "./upload.ts?vue&type=script&lang=ts&external"
export * from "./upload.ts?vue&type=script&lang=ts&external"

import "./upload.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__